<template>
  <div>
    <v-card class="mx-auto mt-5" outlined >
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <image-upload @complete="updateImg"></image-upload>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-img :src="src" :lazy-src="src" aspect-ratio="2" class="grey lighten-2">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import ImageUpload from './uploadimg-create'
  export default {
    components: {
      ImageUpload
    },
    data() {
      return {
        src:'',
      };
    },

    methods: {
      GetData(){

      },
      updateImg(data){
        console.log(data)
        this.src = data.src;
      }
    },
    mounted() {
      this.req = this.$store.getters.req;
    },



  };
</script>
